<template>
	<router-view/>
</template>
<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";

// Main demo style scss
@import "assets/sass/style.vue";
</style>
<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
	export default {
		data(){
			return {
			};
		},
		computed: {
			USER(){
				return this.$store.state.user;
			},
		},
		methods: {
		},
		mounted(){
			this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
		}
	}
</script>
